import styled from "styled-components";

export const StyledAppIconWrapper = styled.div`
  border: 2px solid ${({ theme }) => theme.palette.text.primary};
  height: fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  border-radius: 6px;
`;
